import SvgIcon from 'components/SvgIcon/SvgIcon'
import { useState } from 'react'
import { toastr } from 'react-redux-toastr'
import './WpSearchField.scss'

const WpSearchField = ({ isScrolled, isSearchOpen, setIsSearchOpen }) => {
  const [searchText, setSearchText] = useState('')
  const wordpressUrl = process.env?.REACT_APP_WORDPRESS_URL

  const handleSearchIconClick = () => {
    setIsSearchOpen(true)
  }

  const handleSearch = () => {
    if (!wordpressUrl) {
      toastr?.error?.('Error', 'WordPress URL is not configured')
      return
    }
    
    const searchQuery = encodeURIComponent ? encodeURIComponent(searchText) : searchText
    const formattedQuery = searchQuery && searchQuery.replace ? searchQuery.replace(/\%20/g, '+') : searchQuery
    
    if (window && window.location) {
      window.location.href = `${wordpressUrl}/?s=${formattedQuery}`
    }
  }

  const handleCloseSearch = () => {
    if (!searchText) {
      setIsSearchOpen(false)
    } else {
      handleSearch()
    }
  }

  const handleInputChange = (e) => {
    setSearchText(e?.target?.value)
  }

  const handleKeyDown = (e) => {
    if (e?.key === 'Enter' && searchText) {
      handleSearch()
    }
  }

  return (
    <li className={`blueMenuItem searchMenuItem ${isScrolled ? 'scrolled' : ''}`}>
      {!isSearchOpen ? (
        <div onClick={handleSearchIconClick}>
          <SvgIcon name='wpsearch'/>
        </div>
      ) : (
        <div className='searchInputContainer'>
          <input
            type='text'
            placeholder='Ce dorești să cauți?'
            value={searchText}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            autoFocus
          />
          <div className='searchEndAdornment' onClick={handleCloseSearch}>
            <SvgIcon name='wpsearch' className='greyIcon'/>
          </div>
        </div>
      )}
    </li>
  )
}

export default WpSearchField
